import { Link } from 'react-router-dom';

function name(original) {
  return (
    <Link to={`/workflows/edit/${original?.id}`}>{original?.name || ''}</Link>
  );
}

function description(original) {
  return original?.description || '';
}

function path(original) {
  return original?.path || '';
}

function isActive(original) {
  return original?.isActive ? 'Active' : 'In-Active';
}

export { name, description, path, isActive };
